export const RIDER_LANGUAGES = {
    ENGLISH: 'en',
    ARABIC: 'ar',
  };
  